import { useMutation } from "@connectrpc/connect-query";
import { NPSService } from "@viajero/proto/guest/v1";

/**
 * NPSService.SubmitNPSAnswer を connect-query mutation でラップするフック。
 *
 * アンケート画面の「送信」で星の数 (1〜5) と自由記入欄を保存する。`x-nps-token` ヘッダは
 * lib/client.ts の npsTokenInterceptor が付与するため、呼び出し側はトークンを意識しなくてよい
 * (§6.7)。1 予約 = 1 回答のため、回答済みトークンでの再回答は FailedPrecondition になる。
 */
export function useSubmitNPSAnswer() {
  return useMutation(NPSService.method.submitNPSAnswer);
}
